import React from 'react';
import { Link } from 'react-router-dom';
import style from './navbar.module.css';
import logo from './lily_icon.png';
import Connect from '../Connect';

export default function Navbar({navLinks, onBlogClick}) {
  console.log("Nav bar being rendered");
  console.log("----------------------");

  const [active, setActive] = React.useState(false);

  const handleClick = () => {
    if(active) {
      setActive(false);
    }
  }

  return (
    <nav className={style.navbar}>
      <Logo />
      <ul className={`${style.navbarNav} ${active && style.active}`}>
        {navLinks.map((links, index) => <NavItem key={index} 
        something={links.title}
        title={links.title} 
        path={links.pathId}
        handleBlogClick={onBlogClick}
        handleClick={handleClick}/>)}
        {active ? (
          <div className={style.navConnect}>
            <Connect />
          </div>
        ) : null}
      </ul>
      <Hamburger 
      handleClick={setActive}
      state={active} />
    </nav>
  )
}

function NavItem({
  title, 
  path, 
  something,
handleBlogClick,
handleClick}) {

  return <li className={`${style['navItem']} ${style[something]}`}>
    {path === "/blog" ? <Link onClick={() => {handleBlogClick(true); handleClick();}} to={path}>{title}</Link> : <a href={path} onClick={() => {handleBlogClick(false); handleClick();}}>{title}</a> }
    </li>
}

function Logo() {
  return <img className={style.logo} src={logo} />  
}

function Hamburger({handleClick, state}) {
  return ( 
    <div className={`${style.hamburgerIcon} ${state && style.active}`} onClick={() => handleClick(!state)}>
      <span style={{'--i': 1}}></span>
      <span style={{'--i': 2}}></span>
      <span style={{'--i': 3}}></span>
    </div>
  )
}